var map = {
	"./calculator/Settings.jsx": [
		41291,
		291
	],
	"./edxnotes/Settings.jsx": [
		71754,
		754
	],
	"./live/Settings.jsx": [
		98488,
		488
	],
	"./proctoring/Settings.jsx": [
		83922,
		922
	],
	"./progress/Settings.jsx": [
		90652,
		652
	],
	"./teams/Settings.jsx": [
		64018,
		18
	],
	"./wiki/Settings.jsx": [
		74706,
		706
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 56497;
module.exports = webpackAsyncContext;